import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { Card, Col, Form, FormInstance, Row } from 'antd';
import { useInvoiceFormContext } from '../../../InvoiceFormProvider';

interface Props {
  form: FormInstance;
}

const InvoiceServiceIbtpForm: React.FC<Props> = ({ form }) => {
  const { disabledFields } = useInvoiceFormContext();

  return (
    <Form form={form} preserve={false} disabled={disabledFields}>
      <Card title="IBPT Simplificado" type="inner" style={{ marginBottom: 24 }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'ibtp', 'generalIbptRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Valor da alíquota"
              name={['itemTaxes', 'ibtp', 'generalIbptValue']}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>

      <Card title="IBPT Detalhado" type="inner">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota municipal"
              name={['itemTaxes', 'ibtp', 'municipalIbptRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Valor da alíquota municipal"
              name={['itemTaxes', 'ibtp', 'municipalIbptValue']}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota estadual"
              name={['itemTaxes', 'ibtp', 'stateIbptRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Valor da alíquota estadual"
              name={['itemTaxes', 'ibtp', 'stateIbptValue']}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Alíquota federal"
              name={['itemTaxes', 'ibtp', 'federalIbptRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Valor da alíquota federal"
              name={['itemTaxes', 'ibtp', 'federalIbptValue']}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>
    </Form>
  );
};

export default InvoiceServiceIbtpForm;
